export const getAuthErrorMessage = (code, context = "auth") => {
    const messages = {
      "auth/user-not-found": "This email is not registered. Please sign up first.",
      "auth/wrong-password": "Incorrect password. Please try again or use 'Forgot Password'.",
      "auth/email-already-in-use": {
        signup: "This email is already registered. Please sign in or use 'Forgot Password'.",
        default: "This email is already in use."
      },
      "auth/invalid-email": "The email address format is invalid.",
      "auth/too-many-requests": "Too many attempts. Please wait and try again.",
      "auth/internal-error": "Something went wrong. Please try again later.",
      "auth/invalid-credential": "The provided credential is incorrect or expired."
    };
  
    const message = messages[code];
  
    if (typeof message === "string") return message;
    if (typeof message === "object" && context in message) return message[context];
  
    return message?.default || "An unexpected error occurred. Please try again.";
  };
  